// extracted by mini-css-extract-plugin
export var color1 = "Footer-module--color1--93VN0";
export var color2 = "Footer-module--color2--c4fMf";
export var footerContainer = "Footer-module--footerContainer--aqR0t";
export var root = "Footer-module--root--OI4fv";
export var socialIcons = "Footer-module--socialIcons--ngccx";